import React, {memo, useState, Fragment} from "react";
import {useTranslation} from "react-i18next";
//local
import SubHeading from "components/SubHeading";
import {ButtonTransparent} from "components/buttons/ButtonTransparent";
import {IconPapers, IconCog} from "components/icons";
import {OurProfilesModal} from "pages/SignContracts/components/OurProfilesModal";
import {Info} from "components/Info";
import {showError} from "helpers/notifications.helper";

const SignContractInvoicingProfilesSettings = memo(({isOwner}) => {
  const {t} = useTranslation();

  const [isOurProfilesModal, setOurProfilesModal] = useState(false);

  return (
    <Fragment>
      <div className="organization-settings">
        <SubHeading
          title="SIGN_CONTRACT_INVOICING_PROFILES_SETTINGS"
          icon={<IconPapers />}
        />
        <div className="mt-2">
          <i>{t("SIGN_CONTRACT_INVOICING_PROFILES_SETTINGS_DESCRIPTION")}</i>
        </div>
        <div className="df-row-center mt-1">
          <ButtonTransparent
            name="SIGN_CONTRACT_INVOICING_PROFILES_SETTINGS_BUTTON"
            icon={<IconCog />}
            noBorder
            small
            addClass="fz-14 pl-0 __rotate-on-hover"
            onClick={() =>
              isOwner
                ? setOurProfilesModal(true)
                : showError("WRONG_PRIVILEGES_ONLY_OWNER")
            }
          />
          <Info
            tooltip="SIGN_CONTRACT_INVOICING_PROFILES_SETTINGS_BUTTON_TOOLTIP"
            centerText
          />
        </div>
      </div>
      {isOurProfilesModal && (
        <OurProfilesModal onClose={() => setOurProfilesModal(false)} isOwner={isOwner} />
      )}
    </Fragment>
  );
});

export default SignContractInvoicingProfilesSettings;
